import { render, staticRenderFns } from "./DetailsMask.vue?vue&type=template&id=0f728a10&scoped=true&"
import script from "./DetailsMask.vue?vue&type=script&lang=js&"
export * from "./DetailsMask.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMask.vue?vue&type=style&index=0&id=0f728a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f728a10",
  null
  
)

export default component.exports